import { styled } from '@mui/material/styles';
import { Box, Button, useScrollTrigger } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import { useLandingAnalytics } from '../hooks/useLandingAnalytics';

const StickyContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'visible',
})<{ visible: boolean }>(({ theme, visible }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: theme.zIndex.appBar - 1,
  padding: theme.spacing(1.5, 2),
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.divider}`,
  boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.08)',
  transform: visible ? 'translateY(0)' : 'translateY(100%)',
  transition: 'transform 0.3s ease',
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

export function MobileStickyBar() {
  const navigate = useNavigate();
  const { track } = useLandingAnalytics();
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 400,
  });

  return (
    <StickyContainer visible={trigger}>
      <Button
        variant="contained"
        fullWidth
        startIcon={<SearchIcon />}
        onClick={() => {
          track({ action: 'mobile_sticky_click' });
          navigate('/venues');
        }}
        sx={(theme) => ({
          fontFamily: theme.typography.fontFamilyMono,
          fontWeight: 500,
          textTransform: 'none',
          py: 1.5,
          borderRadius: 2,
          background: theme.palette.gradients?.buttonPrimary,
          color: theme.palette.primary.contrastText,
          '&:hover': {
            background: theme.palette.gradients?.buttonPrimaryHover,
          },
        })}
      >
        Browse Venues
      </Button>
    </StickyContainer>
  );
}
